<template>
    <div class="tabset clearfix">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs"
            role="tablist">
            <li class="nav-item"
                :class="{active: tab.active, disabled: tab.disabled}"
                v-for="tab in tabs">
                <a class="nav-link"
                   href="#{{ $index }}"
                   role="tab"
                   data-toggle="tab"
                   @click.stop.prevent="activateTab($index)">
                    {{{ tab.header }}}
                </a>
            </li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    export default {
        data() {
            return {
                tabs: []
            };
        },
        methods: {
            activateTab(index) {
                const tab = this.tabs[index];

                if (tab && !tab.disabled) {
                    if (index === 'first') {
                        index = 0;
                    } else if (index === 'last') {
                        index = this.tabs.length - 1;
                    }

                    this.tabs.forEach(function (tab, idx) {
                        tab.active = idx === index;
                    });
                }
            },
            registerTab(tab) {
                tab.id = this.tabs.length;
                tab.active = this.tabs.length === 0;

                this.tabs.push(tab);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// TabSet.vue?879c111c